import React, { useState, useEffect } from 'react'
import Mail, { MailsByDomiciliations } from 'globals/models/Mail'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { IconMail } from 'components/Icons'
import ClientMails from 'pages/ClientDetails/components/ClientMails'
import MobileMail from 'components/MobileMail'
import { isMobile } from 'react-device-detect'
import {
  DomiciliationsListScrollPanel,
  EmptyListWrapper,
  DomiciliationMails,
  DomiciliationMailsContent
} from './styles'
import DomiciliationHeaderLine from './DomiciliationHeaderLine'

interface IProps {
  selectedMailsIds: React.Key[]
  setSelectedMailsIds: any,
  userMailsByDomiciliation: any,
  totalCount: number,
  onMailClicked: (mail: Mail) => void,
  scrollLoader?: any,
  alwaysHideCheckboxes?: boolean,
  quickAction?: string,
  quickActionCallback?: any,
  lineStyle?: string,
}

const List = (props: IProps) => {
  const { selectedMailsIds, setSelectedMailsIds, userMailsByDomiciliation, totalCount, onMailClicked } = props

  const [selectedDomiciliationsIds, setSelectedDomiciliationsIds] = useState<number[]>([])

  const onToggleMailSelection = (mailsGroup: Mail[]) => (checkedMailIds: React.Key[]) =>
    setSelectedMailsIds((selectedMails: React.Key[]) => {
      const notSelected = mailsGroup.map((mail) => mail.id).filter((id) => !checkedMailIds.includes(id))
      const toSelect = checkedMailIds.filter((id) => !selectedMails.includes(id as number))

      return selectedMails.concat(toSelect).filter((id) => !notSelected.includes(id as number))
    })

  const onToggleMobileMailSelection = (mail: Mail) => (e: CheckboxChangeEvent) =>
    setSelectedMailsIds((selectedMails: React.Key[]) =>
      e.target.checked ? selectedMails.concat([mail.id]) : selectedMails.filter((mId) => mId !== mail.id)
    )

  const onToggleDomiciliationCheckbox = (domiciliationId: number) => (e: CheckboxChangeEvent) => {
    const domiciliation = userMailsByDomiciliation.find((umbd: any) => umbd.domiciliation.id === domiciliationId)

    if (e.target.checked) {
      setSelectedMailsIds((selectedMailsIds: React.Key[]) =>
        selectedMailsIds.concat(domiciliation.userMails.map((m: Mail) => m.id)))

      setSelectedDomiciliationsIds((domIds: any) => domIds.concat([domiciliationId]))
    } else {
      setSelectedMailsIds((selectedMailsIds: React.Key[]) =>
        selectedMailsIds.filter((id) => !domiciliation.userMails.map((m: Mail) => m.id).includes(id))
      )

      setSelectedDomiciliationsIds((domIds: any) => domIds.filter((id: number) => id !== domiciliationId))
    }
  }

  useEffect(() => {
    userMailsByDomiciliation.map((mails: MailsByDomiciliations) => {
      const allMailsChecked = mails.userMails.every((userMail: any) => selectedMailsIds.includes(userMail.id))
      const domiciliationChecked = selectedDomiciliationsIds.includes(mails.domiciliation.id)

      if (domiciliationChecked && !allMailsChecked) {
        setSelectedDomiciliationsIds((domIds: any) => domIds.filter((id: number) => id !== mails.domiciliation.id))
      } else if (!domiciliationChecked && allMailsChecked) {
        setSelectedDomiciliationsIds((domIds: any) => domIds.concat([mails.domiciliation.id]))
      }
    })
  }, [selectedMailsIds])

  return (
    <DomiciliationsListScrollPanel>
      {
        totalCount === 0 ?
        <EmptyListWrapper>
          <IconMail />
          <span>Aucun courrier à traiter pour le moment !</span>
        </EmptyListWrapper> :
        userMailsByDomiciliation.map((mails: any) =>
          <DomiciliationMails key={mails.domiciliation.id}>
            <DomiciliationHeaderLine
              selectedDomiciliationsIds={selectedDomiciliationsIds}
              mails={mails}
              onToggleDomiciliationCheckbox={onToggleDomiciliationCheckbox}
              hideCheckbox={!!props.alwaysHideCheckboxes}
            />
            <DomiciliationMailsContent>
              {
                !isMobile ?
                <ClientMails
                  data={mails.userMails}
                  selectedMailsIds={selectedMailsIds}
                  setSelectedMailsIds={onToggleMailSelection(mails.userMails)}
                  onMailClicked={onMailClicked}
                  hideHeader
                  showPackages
                  alwaysShowCheckboxes
                  alwaysHideCheckboxes={!!props.alwaysHideCheckboxes}
                  disable={true}
                  quickAction={props.quickAction}
                  quickActionCallback={props.quickActionCallback}
                  lineStyle={props.lineStyle}
                /> :
                mails.userMails.map((mail: any) =>
                  <MobileMail
                    key={mail.id}
                    mail={mail}
                    selected={selectedMailsIds.includes(mail.id)}
                    onChangeSelect={onToggleMobileMailSelection(mail)}
                    onClick={onMailClicked}
                    mailRef={(mail) => mail.sendName}
                  />
                )
              }
            </DomiciliationMailsContent>
          </DomiciliationMails>
        )
      }
      {props.scrollLoader}
    </DomiciliationsListScrollPanel>
  )
}

export default List
